var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.95508 16.5967H9.57129C10.8711 16.5967 11.5264 15.9307 11.5264 14.5234V8.8623C11.5264 7.46582 10.8711 6.7998 9.57129 6.7998H1.95508C0.655273 6.7998 0 7.46582 0 8.8623V14.5234C0 15.9307 0.655273 16.5967 1.95508 16.5967ZM8.58301 7.55176H10.0977V4.54395C10.0977 2.45996 11.4404 1.43945 12.8906 1.43945C14.3301 1.43945 15.6836 2.45996 15.6836 4.54395V6.42383C15.6836 7.00391 16.0166 7.2832 16.4463 7.2832C16.8652 7.2832 17.1982 7.03613 17.1982 6.42383V4.75879C17.1982 1.47168 15.0391 0 12.8906 0C10.7314 0 8.58301 1.47168 8.58301 4.75879V7.55176Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock_icon.a34b9063bf79fe544f436141bc105fd1.svg";
export { ForwardRef as ReactComponent };